
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Step } from '../models/step';

@Injectable()
export class StepService {

    public getStepsPromise: Promise<Step[]>;
    constructor(protected http: HttpClient) { }

    getStepsObservable(url: string, keyJWT: string): Observable<Step[]> {
        const httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'x-access-token': keyJWT,
            })
        };
        return this.http.get(url + '/eazly-api/v1/pages/', httpOptions).pipe(map(
            (response: any) => response,
            // catchError((err: HttpErrorResponse) => {
            catchError((err: any) => throwError(err.json())
            )));
    }

    getSteps(url: string, keyJWT: string): Promise<Step[]> {
        if (!this.getStepsPromise) {
            this.getStepsPromise = new Promise((resolve, reject) => {
                const stepsObservable: Observable<Step[]> = this.getStepsObservable(url, keyJWT).pipe();
                stepsObservable.subscribe(
                    response => {
                        resolve(response);
                        this.getStepsPromise = undefined;
                    },
                    error => {
                        reject(error);
                        this.getStepsPromise = undefined;
                    }
                );
            });
        }
        return this.getStepsPromise;
    }
}
